<template>
  <div>
    <h3 @click="enableDebug($event)" class="display-4">Manage Project</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :list-options="list_options"
      :new-to="{ name: 'ocom_project.create', params: { id: 0 } }"
      :query-select-options="options"
      :schema="schema"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      @filter_changed="update_filter($event)"
      @options_changed="update_table($event)"
      @reset_table="reset_table"
      new-button-text="New Project"
    >
      <template slot="middle">
        <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        />
      </template>
    </o-list-toolbar>

    <b-table
      :fields="fields"
      :items="items"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order == 'desc'"
      @row-selected="onRowSelected"
      @sort-changed="change_sort"
      bordered
      class="o-list"
      head-variant="light"
      no-local-sorting
      selectable
      striped
      thead-class="o-gradient-header"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template
        slot="top-row"
        slot-scope="{ columns, fields }"
        v-if="filterRow"
      >
        <td :key="field.key" class="p-0" v-for="field in fields">
          <span v-if="field.key === 'active_end_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.active_end_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'active_start_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.active_start_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'asana_url'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.asana_url"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'client'">
            <o-form-select
              :loading="optionOcomClientWorking"
              :options="optionOcomClientItems"
              @change="filter_changed"
              blank-option-text=""
              name="client"
              sort-field="name"
              text-field="name"
              v-model="list_options.qbe.client"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'created_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.created_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'database'">
            <o-form-select
              :loading="optionDatabaseWorking"
              :options="optionDatabaseItems"
              @change="filter_changed"
              blank-option-text=""
              name="database"
              sort-field="description"
              text-field="description"
              v-model="list_options.qbe.database"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'date_live'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              hide-time
              v-model="list_options.qbe.date_live"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'date_started'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              hide-time
              v-model="list_options.qbe.date_started"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'demo_site'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.demo_site"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'framework'">
            <o-form-select
              :loading="optionFrameworkWorking"
              :options="optionFrameworkItems"
              @change="filter_changed"
              blank-option-text=""
              name="framework"
              sort-field="description"
              text-field="description"
              v-model="list_options.qbe.framework"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'framework_version'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.framework_version"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'front_end'">
            <o-form-select
              :loading="optionCodeFrontEndWorking"
              :options="optionCodeFrontEndItems"
              @change="filter_changed"
              blank-option-text=""
              name="front_end"
              sort-field="description"
              text-field="description"
              v-model="list_options.qbe.front_end"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'front_end_version'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.front_end_version"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'git_url'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.git_url"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'language'">
            <o-form-select
              :loading="optionLanguageWorking"
              :options="optionLanguageItems"
              @change="filter_changed"
              blank-option-text=""
              name="language"
              sort-field="description"
              text-field="description"
              v-model="list_options.qbe.language"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'language_version'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.language_version"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'live_site'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.live_site"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'logins'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.logins"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'modified_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.modified_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'name'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.name"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'sentry_url'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.sentry_url"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'server_ip'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.server_ip"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'support'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.support"
            ></o-boolean-select>
          </span>
        </td>
      </template>
      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_end_date'"
        >
          <date-display
            :value="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_start_date'"
        >
          <date-display
            :value="item.active_start_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(asana_url)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'asana_url'"
        >
          <default-display :value="item.asana_url"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(client)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'client'"
        >
          <lookup-display
            :list="optionOcomClientItemsById"
            :value="item.client"
            default-value="-"
            display-field="name"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(database)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'database'"
        >
          <lookup-display
            :list="optionDatabaseItemsById"
            :value="item.database"
            default-value="-"
            display-field="description"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_live)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_live'"
        >
          <date-display
            :value="item.date_live"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_started)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_started'"
        >
          <date-display
            :value="item.date_started"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(demo_site)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'demo_site'"
        >
          <default-display :value="item.demo_site"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(framework)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'framework'"
        >
          <lookup-display
            :list="optionFrameworkItemsById"
            :value="item.framework"
            default-value="-"
            display-field="description"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(framework_version)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'framework_version'"
        >
          <default-display :value="item.framework_version"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(front_end)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'front_end'"
        >
          <lookup-display
            :list="optionCodeFrontEndItemsById"
            :value="item.front_end"
            default-value="-"
            display-field="description"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(front_end_version)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'front_end_version'"
        >
          <number-display :decimals="2" :value="item.front_end_version" />
        </o-link-cell>
      </template>
      <template slot="cell(git_url)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'git_url'"
        >
          <default-display :value="item.git_url"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(language)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'language'"
        >
          <lookup-display
            :list="optionLanguageItemsById"
            :value="item.language"
            default-value="-"
            display-field="description"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(language_version)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'language_version'"
        >
          <default-display :value="item.language_version"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(live_site)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'live_site'"
        >
          <default-display :value="item.live_site"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(logins)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'logins'"
        >
          <default-display :value="item.logins"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'name'"
        >
          <default-display :value="item.name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(sentry_url)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'sentry_url'"
        >
          <default-display :value="item.sentry_url"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(server_ip)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'server_ip'"
        >
          <default-display :value="item.server_ip"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(support)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_project.edit', params: { id: item.id } }"
          :when="first_column_key === 'support'"
        >
          <boolean-display :value="item.support"></boolean-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'ocom_project.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :offset="list_options.offset"
      :page-options="rows_per_page_items"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("OcomProject", "ocom_project"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("OcomProject"),
    CreateCodeTableFetchMixin([
      "OcomClient",
      "Language",
      "Framework",
      "Database",
      "CodeFrontEnd",
    ]),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.OcomProject,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.OcomProject),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
      },
    };
  },
  computed: {
    options() {
      return {
        OcomClient: {
          options: this.optionOcomClientItems,
          textField: "name",
          valueField: "id",
        },
        Language: {
          options: this.optionLanguageItems,
          textField: "description",
          valueField: "id",
        },
        Framework: {
          options: this.optionFrameworkItems,
          textField: "description",
          valueField: "id",
        },
        Database: {
          options: this.optionDatabaseItems,
          textField: "description",
          valueField: "id",
        },
        CodeFrontEnd: {
          options: this.optionCodeFrontEndItems,
          textField: "description",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "name",
        "client",
        "support",
        "language",
        "framework",
        "front_end",
        "active_start_date",
        "active_end_date",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>
